import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.initializeHamburgerMenu();
  }

  initializeHamburgerMenu() {
    const hamburgerMenu = document.getElementById('hamburger-menu');
    const sidebar = document.getElementById('sidebar');
    const hamburgerIcon = hamburgerMenu?.querySelector('.hamburger-icon');
    
    if (!hamburgerMenu || !sidebar || !hamburgerIcon) return;
    
    hamburgerMenu.addEventListener('click', () => {
      sidebar.classList.toggle('mobile-visible');
      hamburgerIcon.classList.toggle('open');
    });
    
    // Close sidebar when clicking outside of it on mobile
    document.addEventListener('click', (event) => {
      if (window.innerWidth <= 768 && 
          !sidebar.contains(event.target) && 
          !hamburgerMenu.contains(event.target) && 
          sidebar.classList.contains('mobile-visible')) {
        sidebar.classList.remove('mobile-visible');
        hamburgerIcon.classList.remove('open');
      }
    });
    
    // Handle window resize
    window.addEventListener('resize', () => {
      if (window.innerWidth > 768) {
        sidebar.classList.remove('mobile-visible');
        hamburgerIcon.classList.remove('open');
      }
    });
  }
}
